import { styleTime } from './styles';

export const gatherColumns = (data: any[], idx: number) => {
    return data.flatMap((row: any) => row[idx]);
};

export const sum = (data: any[]) => {
    return data.reduce((acc: number, item: number) => acc + item, 0);
};

export const average = (data: any[]) => {
    return parseFloat((sum(data) / data.length).toFixed(2));
};

export const count = (data: any[]) => {
    return data.length;
};

export const countUnique = (data: any[]) => {
    return Array.from(new Set(data)).length;
};

export const countUniqueTime = (data: any[]) => {
    return countUnique(data.map((date) => styleTime(date)));
};

export const override = (data: any) => () => {
    return data;
};

export const none = () => {
    return '';
};
